import React from 'react';
import ModalContainer from "../../common/modal_container";
import {exportNewCasinoJson} from "../../../data/gameData_casino";
import GameList from "../../list/game_list";

export default function CasinoModal({popShow, setPopShow}: {popShow: boolean; setPopShow: Function;}){
    return (
        <ModalContainer show={popShow}
                        setShow={setPopShow}
                        closeBtn={true}
                        className={'casino-popup'}
        >
            <GameList title={'LIVE CASINO'} type={'casino'} list={exportNewCasinoJson as []}/>
        </ModalContainer>
    )
}
